import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

const TOUCH_MODE_BREAKPOINT = 1024;

interface TouchModeContextValue {
  isTouchMode: boolean;
}

const TouchModeContext = createContext<TouchModeContextValue | undefined>(
  undefined
);

interface TouchModeProviderProps {
  children: ReactNode;
}

export function TouchModeProvider({ children }: TouchModeProviderProps) {
  const [isTouchMode, setIsTouchMode] = useState(() => {
    return window.innerWidth <= TOUCH_MODE_BREAKPOINT;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${TOUCH_MODE_BREAKPOINT}px)`);

    const handler = (e: MediaQueryListEvent) => {
      setIsTouchMode(e.matches);
    };

    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    document.body.dataset.touchMode = isTouchMode ? "true" : "false";
  }, [isTouchMode]);

  return (
    <TouchModeContext.Provider value={{ isTouchMode }}>
      {children}
    </TouchModeContext.Provider>
  );
}

export function useTouchMode(): boolean {
  const context = useContext(TouchModeContext);

  if (context === undefined) {
    throw new Error("useTouchMode must be used within a TouchModeProvider");
  }

  return context.isTouchMode;
}
